export default {
	title: 'Terminal Channel',
	selectAll: 'Select All',
	selectedCount: 'Selected {count} items',
	batchDelete: 'Batch Delete',
	batchDeleteWithCount: 'Batch Delete ({count})',
	noData: {
		title: 'No Terminal Channel Data',
		description: 'No terminal channel data found'
	},
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Delete successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		projNo: 'Project',
		orgId: 'Organization',
		terminalId: 'Terminal ID',
		terminalNumber: 'Terminal Number',
		channel: 'Channel',
		hasSensor: 'Has Sensor',
		deviceId: 'Device',
		sensorName: 'Sensor Name',
		dataType: 'Data Type',
		dataStatus: 'Data Status',
		placeholder: {
			projNo: 'Please select project',
			orgId: 'Please select organization',
			terminalId: 'Please enter terminal ID',
			terminalNumber: 'Please enter terminal number',
			channel: 'Please enter channel',
			hasSensor: 'Please select has sensor',
			deviceId: 'Please select device',
			sensorName: 'Please enter sensor name',
			dataType: 'Please select data type',
			dataStatus: 'Please select data status'
		}
	},
	table: {
		projNo: 'Project No',
		orgId: 'Organization',
		terminalId: 'Terminal ID',
		terminalNumber: 'Terminal Number',
		channel: 'Channel',
		hasSensor: 'Has Sensor',
		deivceName: 'Device Name',
		sensorName: 'Sensor Name',
		dataType: 'Data Type',
		dataStatus: 'Data Status'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	options: {
		hasSensor: {
			yes: 'Yes',
			no: 'No'
		},
		dataType: {
			vibration: 'Vibration',
			tempVibration: 'Temp & Vibration',
			tempVibrationSound: 'Temp, Vibration & Sound',
			current: 'Current',
			speed: 'Speed'
		},
		dataStatus: {
			normal: 'Normal',
			abnormal: 'Abnormal',
			noData: 'No Data'
		}
	}
}
